import { Communication } from './Communication';
export class ContactPerson {
    constructor() {
        this.salutation = null;
        this.name = null;
        this.communication = new Communication();
    }
}
